import { ILLUSTRATIONS, modalExpandedWidth } from "../../helpers/imageConstants";

export const illustrations = [
  {
    id: "illustration-16",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.slunecnice,
  },
  {
    id: "illustration-30",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.pandaCervena,
  },
  {
    id: "illustration-29",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.duch,
  },
  {
    id: "illustration-14",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.psychoZaba,
  },
  {
    id: "illustration-28",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.vilaParez,
  },
  {
    id: "illustration-27",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.vilaGreen,
  },
  {
    id: "illustration-25",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.ovecka,
  },
  {
    id: "illustration-23",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.zirafkaGreen,
  },
  {
    id: "illustration-22",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.hrosikRed,
  },
  {
    id: "illustration-20",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.plamenak,
  },
  {
    id: "illustration-18",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.velrybyWhite,
  },
  {
    id: "illustration-13",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.meduzkaBlue,
  },
];

export const illustrations1 = [
  {
    id: "b1",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.b1,
    width: modalExpandedWidth,
  },
  {
    id: "b2",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.b2,
    width: modalExpandedWidth,
  },
  {
    id: "b7",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.b7,
    width: modalExpandedWidth,
  },
];

export const illustrations2 = [
  {
    id: "b3",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.b3,
    width: modalExpandedWidth,
  },
  {
    id: "b6",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.b6,
    width: modalExpandedWidth,
  },
  {
    id: "b5",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.b5,
    width: modalExpandedWidth,
  },
  {
    id: "b4",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.b4,
    width: modalExpandedWidth,
  },
];

export const illustrations3 = [
  {
    id: "illustration-12",
    name: "",
    alt: "",
    description: "",
    size: "",
    date: "2022",
    src: ILLUSTRATIONS.spiciDrak,
    width: modalExpandedWidth,
  },
];
